import { BlockStack, InlineStack, Text, Badge, Button } from '@shopify/polaris';
import BrandAvatar from '@/components/BrandAvatar';
import { IAiConnection } from '@/types/aiAssistants';
import { AI_STRINGS } from '../../config';
import { StyledRow } from './styled';

interface IClaudeRowProps {
  connection: IAiConnection | null;
  isLoading: boolean;
  onConnect: () => void;
  onDisconnect: () => void;
}

const formatDate = (iso: string): string => {
  try {
    return new Date(iso).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  } catch {
    return iso;
  }
};

const formatRelative = (iso: string): string => {
  try {
    return new Date(iso).toLocaleString('en-US', { dateStyle: 'short', timeStyle: 'short' });
  } catch {
    return iso;
  }
};

const ClaudeRow = ({ connection, isLoading, onConnect, onDisconnect }: IClaudeRowProps) => {
  const isConnected = !!connection;
  return (
    <StyledRow data-testid="claude-row">
      <BrandAvatar brand="claude" />
      <BlockStack gap="100">
        <InlineStack gap="200" blockAlign="center">
          <Text as="span" variant="headingSm">
            Claude
          </Text>
          <Text as="span" tone="subdued" variant="bodySm">
            by Anthropic
          </Text>
          <Badge tone={isConnected ? 'success' : 'info'}>{isConnected ? AI_STRINGS.BADGE_CONNECTED : 'Instant connection'}</Badge>
        </InlineStack>
        {!isConnected && (
          <Text as="p" tone="subdued">
            {AI_STRINGS.CLAUDE_DESCRIPTION}
          </Text>
        )}
        {isConnected && connection && (
          <BlockStack gap="050">
            <Text as="p" tone="subdued" variant="bodySm">
              {AI_STRINGS.CONNECTED_ON(formatDate(connection.connectedAt))}
            </Text>
            <Text as="p" tone="subdued" variant="bodySm">
              {connection.lastUsedAt ? AI_STRINGS.LAST_USED(formatRelative(connection.lastUsedAt)) : AI_STRINGS.NEVER_USED}
            </Text>
          </BlockStack>
        )}
      </BlockStack>
      <div className="actions">
        {isConnected ? (
          <Button onClick={onDisconnect}>{AI_STRINGS.BUTTON_DISCONNECT}</Button>
        ) : (
          <Button variant="primary" onClick={onConnect} loading={isLoading}>
            {AI_STRINGS.BUTTON_CONNECT}
          </Button>
        )}
      </div>
    </StyledRow>
  );
};

export default ClaudeRow;
